import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Role } from '../../models/shared/role.model';
import { RoleService } from '../../services/role/role.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.css']
})
/** role-list component*/
export class RoleListComponent {
   
  public roleList: Role[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** role-list ctor */
  constructor(private readonly roleService: RoleService, private readonly utilitiesService: UtilitiesService, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("role").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.GetRoles();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  GetRoles() {
    this.roleService.GetRoles().subscribe(
      data => {
        this.roleList = data;
        this.filteredItems = data;
      }
    )
  }

  deleteRole(id) {
    var ans = confirm("Are you sure to delete this role?");
    if (ans) {
      this.roleService.DeleteRole(id).subscribe(result => {
        if (result) {
          setTimeout(() => {
            this.GetRoles();
          }, 2000);
        }
        else { }
      });
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.roleList, searchText);

    } else {
      this.filteredItems = this.roleList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/role-components/role-list/role-list.component.ts